<script>
  export default {
    name: "WidgetImageGallery",
    props: {
      /** An array of image objects which include "small", "large" image URLs */
      images: {
        type: Array,
        default: () => []
      }
    },
    computed: {
      gallery() {
        const gallery = [];
        this.images.forEach((image) => {
          gallery.push({
            src: image.large,
            thumbnail: image.small,
          });
        })
        return gallery;
      }
    }
  }
</script>

<template>
  <div class="widget-wrapper">
    <div class="callout--gallery-with-text">
      <silent-box :gallery="gallery"></silent-box>
    </div>
  </div>
</template>

<style scoped>
  #silentbox-gallery {
    margin: 30px 0 0 0;
  }
</style>